import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import type {RootLoaderResponse, SearchCategory} from '~/types'

interface DropdownOptionProps {
  category: SearchCategory
  query?: string
}

const highlightText = (text: string, query: string, _locale: string) => {
  const parts = text.split(new RegExp(`(${query})`, 'gi'))
  return (
    <span>
      {parts.map((part, i) =>
        part.toLowerCase() === query?.toLowerCase() ? (
          <span key={`${part}-${i}`} className="font-extrabold">
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </span>
  )
}

const DropdownOption = ({category, query = ''}: DropdownOptionProps) => {
  const {locale} = useRouteLoaderData('root') as RootLoaderResponse

  return (
    <div className="flex h-14 w-full flex-row items-center gap-4 bg-blend-multiply">
      <div className="flex h-10 w-10 justify-center rounded bg-gray-50 p-1 mix-blend-multiply">
        <img src={category.image} alt={category.displayName} className="object-contain mix-blend-multiply" />
      </div>
      <span className="flex h-full w-full cursor-pointer items-center text-sm font-normal text-zinc-500">
        {highlightText(category.displayName, query, locale)}
      </span>
    </div>
  )
}

export default DropdownOption
